import React from 'react';

class ServerApps extends React.Component {

  render() {
    let hostInfo = this.props.hostInfo;
    let serverInfo = hostInfo.serverInfo;

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>server applications</div>
        </div>

        <div className='version-block'>
          {getInstalledAppList(serverInfo).map((app) => {
            return (
              <div className="pure-g" key={app.name}>
                <div className="pure-u-6-24" style={{color: (app.running ? '' : 'darkered')}}>
                  <i className={app.running ? "fa fa-fw fa-plug app-running" : "fa fa-fw fa-plug app-stopped"}/>
                  {app.name}
                </div>
                <div className='pure-u-8-24' style={{ color: app.running ? '' : 'darkred' }}>
                  {app.version}
                </div>
                <div
                  className='pure-u-10-24 status'
                  style={{ color: app.running ? '' : 'darkred' }}
                >
                  {app.status}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function getInstalledAppList(serverInfo) {
  let appList = [];
  for (let name in serverInfo.app) {
    let app = serverInfo.app[name];
    if (app && app.installed) {
      appList.push(app);
    }
  }
  return appList;
}

export default ServerApps;



// WEBPACK FOOTER //
// ./src/components/ServerApps.js